import React from "react"
import styled from "styled-components"

const SaturationWrapper = styled.g`
  .st2bwg,
  .st4bwg,
  .st6bwg {
    fill: none;
    stroke: #000;
    stroke-width: 2;
  }
  .st4bwg,
  .st6bwg {
    stroke: #b3b3b3;
  }
  .st6bwg {
    stroke: #fff;
  }

  .st1swirl {
    fill: #ff15fb;
  }
  .st2swirl {
    fill: #f8ff15;
  }
  .st3swirl {
    fill: #0aff1e;
  }
  .st4swirl {
    fill: #f4001a;
  }
  .st5swirl {
    fill: #110aff;
  }
  .st6swirl {
    fill: #05f4ff;
  }
  .st7swirl {
    fill: #ff7d05;
  }
  .st8swirl {
    fill: none;
    stroke: #fff;
    stroke-width: 3;
  }

  .st15 {
    fill: none;
    stroke: #000000;
    stroke-miterlimit: 10;
  }
  .st16 {
    stroke: #000000;
    stroke-miterlimit: 10;
  }
  .st1limbs,
  .st2limbs {
    fill: none;
    stroke: #fff;
    stroke-width: 3;
  }
  .st2limbs {
    stroke-width: 4;
  }
  .st19 {
    fill: none;
    stroke: #fff;
    stroke-width: 3;
  }

  text {
    font-size: 4rem;
  }
`

const SaturationIcon = () => (
  <SaturationWrapper>
    <filter id="swirl-blur" y="-5" x="-10" height="40" width="60">
      <feGaussianBlur stdDeviation="10 0"></feGaussianBlur>
    </filter>
    <circle className="icon-bg" cx="150" cy="150" r="150" fill="#5f6470" />

    <g id="BLACK_2">
      <g id="pitcher_3">
        <path d="M79.37 137.89c10.39-14.86 35.98-46.54 1.4-43.17l-3.33 2.13s-.12 4.32.01 5.46c24.37-14.31 1.16 31.34-6.92 33.32-1.51.37-8.19-.16-8.75.4-1.34 1.35-3.31 4.95-3.31 4.95 4.51-4.29 13.53.28 20.9-3.09z" />
        <path
          d="M4.71 118.55C5 126 5 133 7 140c15 4 30 5 45 9 12-15 22-33 26.49-51.52-4.37 1.12-3.44 14.29 0 0C77 97 76 98 75 98c-21-4-40-6-59.53-10.63"
          className="st2bwg"
        />
      </g>
      <g id="top_3">
        <path
          d="M30.69 81.09l20.92 3.86c3.85.98 4.67-.32 3.63-2.34.12-6.11-18.41-7.05-23.48-7.34-1.71-.32-3.34.73-3.64 2.34-2.25 1.5-.75 3.07 2.57 3.48z"
          className="st2bwg"
        />
        <path
          d="M15.68 87.41C20 90 25 90 29 91c15 2 29 7 45 5 1 0 3 0 3-1 1-3-3-4-5-5-17-5-34-8-52.13-9.83"
          className="st2bwg"
        />
      </g>
      <path d="M54.14 196.58c-2.55-4.85 4.67-28.96-1.85-45.75 3.92.42 1.77-1.41 1.77-1.41l-.03-.38c-16.29-2.67-32.57-5.37-48.85-8.08L2 162c-1.74 4.61 6.5 40.57 8.92 41.41 13.56 2.78 27.54 4.69 39.01 5.55 1.27.09-.63-4.7.59-5.07 2.22-.66 7.1-.7 3.62-7.31z" />
    </g>
    <g id="GREY_2">
      <g id="pitcher_2">
        <path
          fill="#b3b3b3"
          d="M122.42 227.4c-18.03-3.67-57.87-14.69-40.76 16.14l3.33 2.24s4.07-1.63 5.08-2.22c-23.17-16.91 28.71-13.74 33.81-7.02.95 1.26 3.16 7.69 3.91 7.98 1.79.7 5.95 1.08 5.95 1.08-5.8-2.46-5.19-12.71-11.32-18.2z"
        />
        <path
          d="M144.93 298.02C148 295 154 295 153 290c-4-14-6-28-10-42-19-4-39-7-57.83-3.45 1.73 2.27 14.26-2.5 0 0C86 246 87 246 87 247c2 15 7 28 9.88 42.4"
          className="st4bwg"
        />
        <g id="top_2">
          <path
            d="M86.37 284.64l-2-10c-.65-3.98-3.18-5.22-4.64-3.44-1.73 1.8-2.66 3.85-1.6 8.96"
            className="st4bwg"
          />
          <path
            d="M97.43 289.53C95 277 91 266 88 253c-1-2-2-5-4-6-1 0-2 1-2 1-3 13 2 25 4.33 36.69"
            className="st4bwg"
          />
        </g>
      </g>
      <path
        fill="#bfbfbf"
        stroke="#b3b3b3"
        d="M201.86 225.96c-.4-1.21-4.11 2.38-4.91 1.38-1.46-1.81-3.35-6.31-8.14-.58-3.51 4.21-28.56 6.7-41.61 19.12-1.11-3.79-1.98-1.09-1.98-1.09l-.34.17c3.72 16.08 7.43 32.16 11.12 48.25.9-.86 1.81-1.91 2.51-2.21 7 3.37 19.94 3.4 29.73 2.82 1.46-.43 2.92-.72 4.33-.84 2.76-1.28 5.71-2.13 8.45-2.32 2.45-1.52 5.23-2.74 7.98-3.44 1.6-1.28 3.45-2.45 5.43-3.4-1.7-9.8-7.53-42.43-12.57-57.86z"
      />
    </g>
    <g id="WHITE_2">
      <g id="top_1">
        <path
          d="M284.13 85.02c-5.76-2.31-9.25-2.46-12.43-2.91-1.7-.46-4.44.46-4.87 2.06-2.41 1.32-.03 3.04 3.3 3.74l16.07 4.19"
          className="st6bwg"
        />
        <path
          d="M287.25 92.57c-20.48-6.1-35.25-9.76-45.75-8.17-10.5 1.6 21.54 11.48 49.71 18.24"
          className="st6bwg"
        />
      </g>
      <path
        fill="#fff"
        d="M288 161.28c-16.01-4-32.02-8.01-48.03-12.05.36 1.19.88 2.48.83 3.24-10.8 8.2-20.8 37.2-20.8 37.2s-4 0-5 5c0 0-.81 1.19 3 5 2 2 1 5 1 5s41 13 60 16c1.26.2-.25-4.74 1-5 2.27-.48 7.14-.12 4.22-6.99-2.15-5.04 7.03-28.48 1.91-45.75 3.88.73 1.88-1.27 1.88-1.27v-.38z"
      />
      <g id="pitcher_1">
        <path
          d="M242 149.92c7.29 2.32 43.99 14.85 47.09 10.39.29-1.09-.75-2.32-2.33-2.73-14.88-3.3-29.46-7.16-43.71-11.61-3.68-1.02-4.77 3-1.05 3.95z"
          className="st6bwg"
        />
        <path
          d="M289.17 101.7c-20.74-5.36-45.14-11.75-50.01-13.88-8.38-2.93 2.43 6.37 1.89 9.61-1.81 10.94-.21 35.38 1.99 48.53l43.54 12.27c3.66-.73 10.41-14.23 11.59-21.27"
          className="st6bwg"
        />
      </g>
    </g>

    <g id="pitcher_1_">
      <g id="swirlblur" filter="url(#swirl-blur)">
        <path
          d="M191.38 92.01c-27.29-7.74-61.07 7.14-88.82-.44 7.65 37.52 58.82 8.65 84.88 11.02 1.12-4.61 2.82-5.95 3.94-10.58z"
          className="st1swirl"
        />
        <path
          d="M196.92 63.74C149.44 50 145.79 37.03 89.46 47.59c1.93 25.93 18.06 26.96 40.07 29.18 23.09 5.01 79.02 31.27 67.39-13.03z"
          className="st2swirl"
        />
        <path
          d="M206.14 48.56c11.02-41.32-40.91-26.91-53.98-3.36-16.17 13.3-37.46 19.73-57.94 18.31 1.51 5.05 2.93 9.84 4.28 14.38 42.39 12.75 69.02-29.08 105.18-20.32.87-3.52 2.13-7.66 2.46-9.01z"
          className="st3swirl"
        />
        <path
          d="M187.29 102.67c-26.54-6.06-55.16 4.86-82.2-2.53 1.12 3.83 4.14 7.27 5.14 10.73 20.78.91 69.48 16.52 77.06-8.2z"
          className="st4swirl"
        />
        <path
          d="M197.12 81.35c-33.22-7.04-64.2 10.17-96.26 4.49 17.94 27.55 61.49-2.33 89.83 3.34.84-3.41 5.64-4.57 6.43-7.83z"
          className="st5swirl"
        />
        <path
          d="M193.84 87.91c-32.09-5.82-64.67-16.48-97.19-16.25 1.75 5.86 3.38 11.36 4.91 16.52 29.66.23 59.62 4.79 89.83 4.65.61-2.53 1.85-2.44 2.45-4.92z"
          className="st6swirl"
        />
        <path
          d="M204.5 53.48c-43.53 2.91-68.78-64.14-118.15-16.29 2.33 7.81 4.4 14.72 6.49 21.72 48.82-31.17 108.92 50.17 111.66-5.43z"
          className="st7swirl"
        />
      </g>
      <g id="swirl_1_">
        <path
          d="M186.99 89.65c-24.59-6.97-55.02 6.43-80.02-.39 6.89 33.8 52.99 7.79 76.47 9.93 1-4.16 2.53-5.37 3.55-9.54z"
          className="st1swirl"
        />
        <path
          d="M191.97 64.18c-42.77-12.38-46.06-24.06-96.8-14.54 1.74 23.36 16.27 24.29 36.09 26.29 20.8 4.51 71.19 28.16 60.71-11.75z"
          className="st2swirl"
        />
        <path
          d="M200.28 50.51c9.93-37.22-36.86-24.24-48.63-3.02-14.56 11.98-33.74 17.77-52.19 16.49 1.36 4.55 2.64 8.86 3.86 12.95 38.19 11.49 62.18-26.19 94.75-18.3.77-3.18 1.91-6.91 2.21-8.12z"
          className="st3swirl"
        />
        <path
          d="M183.29 99.25c-23.91-5.45-49.69 4.38-74.05-2.28 1.01 3.45 3.73 6.55 4.63 9.67 18.72.82 62.6 14.89 69.42-7.39z"
          className="st4swirl"
        />
        <path
          d="M192.16 80.05c-29.93-6.34-57.83 9.16-86.71 4.05 16.16 24.82 55.39-2.1 80.93 3.01.74-3.08 5.06-4.12 5.78-7.06z"
          className="st5swirl"
        />
        <path
          d="M189.2 85.96c-28.91-5.24-58.26-14.85-87.56-14.64 1.57 5.28 3.04 10.23 4.42 14.88 26.72.21 53.71 4.32 80.92 4.19.56-2.28 1.68-2.19 2.22-4.43z"
          className="st6swirl"
        />
        <path
          d="M198.8 54.94c-39.22 2.62-61.96-57.78-106.43-14.67 2.1 7.03 3.96 13.26 5.85 19.57 43.97-28.09 98.11 45.19 100.58-4.9z"
          className="st7swirl"
        />
      </g>

      <g id="top_1_">
        <path
          d="M166.91 14.26c.59-6.76-39.75-8.51-39.58-.64-6.83 5.22 44.17 6.2 39.58.64z"
          className="st19"
        />
        <path
          d="M202.5 25.5c0-9-105-11-117 0-1 8 115.33 10.9 117 0z"
          className="st19"
        />
      </g>
      <path
        fill="#fff"
        d="M183.31 114.35c-41.31 1.65-70.39 1.19-70.39 1.19s-10.34 27.25-11.34 37.92l-2.61 20.96c0 3.13 2.54 5.68 5.68 5.68 11.49-.67 91.47 7.14 90.84-5.67l-3.36-28.23-8.82-31.85z"
      />
      <path
        d="M214.62 87.78c11.05-23.83 39.49-75.54-8.98-61.94l-4.21 3.89s.92 6.19 1.4 7.79c31.13-26.61 9.62 44.41-1.4 49.29-2.06.91-11.73 1.86-12.38 2.79-1.57 2.26-3.46 7.91-3.46 7.91 5.34-7.26 19.37-3.03 29.03-9.73zM114.64 115.03c10.91.53 66.14 4.38 68.78-2.92 0-1.61-1.89-2.92-4.21-2.92-21.75.9-43.28.92-64.57 0-5.44-.05-5.47 5.89 0 5.84z"
        className="st8swirl"
      />
      <path
        d="M114.64 109.19l64.57.97c13.7-26.56 22.27-53.15 23.86-79.79 0 2.11-102.47 1.95-115.11 0-12.63-.97 5.69 7.89 6.14 12.57 1.52 15.77 12.69 48.91 20.54 66.25zM123.07 101.41c-6.53-10.19-17.34-41.25-18.25-53.51M104.12 47.89h17.54M106.01 57.72h8.63M109.06 65.5h8.64M111.75 73.29h7.02M114.8 81.07h8.64M117.36 86.91h5.62M120.42 94.69h12.63M123.89 101.5h8.63"
        className="st8swirl"
      />
    </g>

    <path
      id="eyeR_1_"
      d="M155.88,139.65c-0.2-1.18-0.2-2.34,0.06-3.45c0.09-0.57,0.29-1.12,0.52-1.66c0.19-0.55,0.52-1.08,0.87-1.59
				c0.31-0.53,0.82-0.98,1.29-1.45c0.22-0.24,0.56-0.41,0.85-0.6c0.31-0.18,0.59-0.39,0.94-0.51c1.36-0.6,2.93-0.68,4.29-0.39
				c0.65,0.17,1.29,0.4,1.87,0.67c0.53,0.31,1.12,0.59,1.57,0.96c0.96,0.7,1.75,1.51,2.48,2.35c1.41,1.7,2.44,3.6,3.18,5.64
				c-1.86-1.14-3.49-2.38-5.16-3.4c-1.64-1-3.33-1.87-4.69-2c-0.32,0.02-0.65-0.06-0.92,0.04c-0.29,0-0.55,0.14-0.82,0.23
				c-0.52,0.29-1.1,0.64-1.72,1.2c-1.28,1.06-2.56,2.57-4.47,4.02L155.88,139.65z"
    />

    <path
      id="mouth_1_"
      d="M164.33,145.98c1.05,1.17,1.79,2.53,2.27,4.03c0.47,1.49,0.67,3.16,0.3,4.9c-0.32,1.74-1.41,3.48-2.85,4.61
				c-1.45,1.15-3.11,1.76-4.69,2.05c-3.19,0.58-6.21,0.24-9.09-0.36c-2.88-0.62-5.64-1.58-8.27-2.82c2.91,0.09,5.76,0.29,8.56,0.31
				c2.78,0.03,5.56-0.09,7.96-0.74c0.6-0.16,1.15-0.38,1.68-0.61c0.49-0.26,0.97-0.54,1.35-0.87c0.78-0.66,1.25-1.49,1.6-2.52
				c0.35-1.03,0.54-2.27,0.66-3.6c0.13-1.34,0.19-2.77,0.4-4.32L164.33,145.98z"
    />

    <g id="eyeL">
      <path
        className="st15"
        d="M124.37,135.5c-1.42,11.39,16.72,12.74,17.81,1.32C143.6,125.43,125.46,124.08,124.37,135.5z"
      />
      <path
        className="st16"
        d="M137.81,138.02c-0.44,4.75-9.51,4.08-8.91-0.66c0.22-2.02,4.86-9.71,4.86-9.71S138.04,136,137.81,138.02z"
      />
      <path className="st15" d="M121,127.28c1.29,0.28,2.42,1,3.08,1.95" />
      <path className="st15" d="M131.06,122c0.17,0.99,0.35,1.98,0.52,2.98" />
      <path className="st15" d="M144.53,126.67c-0.86,0.57-1.72,1.13-2.59,1.7" />
    </g>
    <defs>
      <path
        id="reuse-0"
        d="M101.92 186.86c30.48 1.4 60.97 1.4 91.45 0 4.68-.03 4.68-11.35 0-11.37 0 0-6.14 5.91-46.41 5.23-45.63.9-45.63-11.18-48.46-.49-.31 2.68.71 6.74 3.42 6.63z"
        className="st1limbs"
      />
      <path
        id="path_2_"
        d="M109.43 193.68c26.84 1.64 53.69 1.64 80.53 0 23.22-12.95-81.8-4.62-80.53-6.83-4.4-.06-4.44 6.9 0 6.83z"
        className="st1limbs"
      />
    </defs>

    <g id="bases_1_">
      <g id="base-blurred_1_">
        <use className="st1limbs" xlinkHref="#path_2_" />
        <use className="st1limbs" xlinkHref="#reuse-0" />
      </g>
    </g>
    <g id="armR_1_">
      <path
        d="M242 148.35l-4.29-.1-18.54 13.63-28.37-3.64M238.07 142.03l-.84 5.93"
        className="st2limbs"
      />
    </g>
    <g id="armL_1_">
      <path
        d="M104.21 154.02L78.1 165.28l-20.82 1.44-3.84 2.05M54.1 161.35l3.47 4.89"
        className="st2limbs"
      />
    </g>
    <path
      id="legL_1_"
      d="M138.07 195.44l-2.18 30.16 1.44 25.13-6.47 6.72"
      className="st2limbs"
    />
    <path
      id="legR_1_"
      d="M153.12 195.44l18.67 13.95 2.44 23.98 5.75-2.43"
      className="st2limbs"
    />
  </SaturationWrapper>
)

export default SaturationIcon
